import { Typography } from "@packages/ds";
import styled from "styled-components";

export const ContentWrapper = styled.div`
  width: 368px;
`;

export const Description = styled(Typography.BodyText)`
  margin: 14px 0;
`;

export const LinkWrapper = styled.div`
  margin-top: 16px;
`;
